module.exports = __webpack_public_path__ + "static/media/emoji-love.29ad6af9.svg";